import React from 'react';
import { PvsInventory } from 'models/interfaces';
import PvsInventoryRowItem from './PvsInventoryRowItem';
import './PvsInventory.scss';

interface PvsInventoryViewProps {
  inventory: PvsInventory[];
}

const PvsInventoryView: React.FunctionComponent<PvsInventoryViewProps> = ({ inventory }) => {
  const verticalRows = inventory.map((x: PvsInventory) => (
    <PvsInventoryRowItem key={x.vertical_id} vertical={x} />
  ));

  return (
    <section className="card">
      {/* <h2>Premium Vertical Sponsorship Inventory</h2> */}
      <table className="table hover">
        <thead>
          <tr>
            <th>Name</th>
            <th className="align-right">Vertical ID</th>
            <th>Inactive</th>
            <th className="align-right">Date Created</th>
            <th className="align-right">Active Campaign Count</th>
            <th className="align-right">Next End Date</th>
            <th>Details</th>
          </tr>
        </thead>
        <tbody>{verticalRows}</tbody>
      </table>
    </section>
  );
};

export default PvsInventoryView;
